exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sale-in-campaign-status__draft{color:#FF9B1A !important}.sale-in-campaign-status__inactive{color:#A66EFA !important}.sale-in-campaign-status__active{color:#24A148 !important}.sale-in-campaign-status__force_closed{color:#767676 !important}\n", ""]);

// exports
